// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1C0rr","consentsList":"PatientConsents_consentsList__1tqR6","consentsListEmpty":"PatientConsents_consentsListEmpty__2XfgN"};